export default "__VITE_ASSET__BHijqCvt__";